import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Context from "../src/AppContext/Context.jsx";
import './index.css';

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

createRoot(rootElement).render(
  <React.StrictMode>
    <Context>
      <App />
    </Context>
  </React.StrictMode>
);

